<ng-container *ngIf="reward">
	<div class="game-bonus-progress-name">{{ reward.title }}</div>
	<obg-progress-bar
		[mode]="progressBarMode"
		[value]="reward.percentageComplete"
		[maxValue]="100"
		hideValues
		roundedCorners
		[options]="{ type: 'percentage' }"
	>
	</obg-progress-bar>
	<div class="game-bonus-progress-text">{{ percentageComplete }}</div>
</ng-container>
